import { getSessions } from '@/lib/collections/sessions';
import { getTenants } from '@/lib/collections/tenants';
import { isMockAuth } from '@/lib/poofClient';

export type MockPublicSession = {
  sessionId: string;
  appid: string;
  tenantName?: string;
  amountUsdCents: number;
  accepts: string;
  chosenRail?: string;
  pdaAddress?: string | null;
  paymentAddress?: string | null;
  solanaPayReference?: string;
  whopCheckoutUrl?: string;
  status: string;
  expiresAt: number;
  successRedirectUrl?: string;
  nativeAmount?: string;
  settledAt?: number;
  txSignature?: string;
  promoCode?: string;
  originalAmountUsdCents?: number;
  discountPercent?: number;
};

export async function getMockPublicSession(sessionId: string): Promise<MockPublicSession | null> {
  if (!isMockAuth()) return null;
  const session = await getSessions(sessionId);
  if (!session) return null;
  const tenant = await getTenants(session.appid);
  const sessionExtras = session as typeof session & {
    nativeAmount?: string;
    pdaAddress?: string | null;
    promoCode?: string;
    originalAmountUsdCents?: number;
    discountPercent?: number;
  };

  return {
    sessionId: session.id,
    appid: session.appid,
    tenantName: tenant?.name,
    amountUsdCents: session.amountUsdCents,
    accepts: session.accepts,
    chosenRail: session.chosenRail,
    pdaAddress: sessionExtras.pdaAddress ?? session.paymentAddress ?? null,
    paymentAddress: session.paymentAddress ?? null,
    solanaPayReference: session.solanaPayReference,
    whopCheckoutUrl: session.whopCheckoutUrl,
    status: session.status,
    expiresAt: session.expiresAt,
    successRedirectUrl: session.successRedirectUrl,
    nativeAmount: sessionExtras.nativeAmount,
    settledAt: session.settledAt,
    txSignature: session.txSignature,
    promoCode: sessionExtras.promoCode,
    originalAmountUsdCents: sessionExtras.originalAmountUsdCents,
    discountPercent: sessionExtras.discountPercent,
  };
}
